import LocomotiveScroll from 'locomotive-scroll';
import { $scroll } from '../stores/scroll';
import { $html } from '../utils/dom';

export class Scroll {
    static lastProgress = 0;
    static scrollOrientation = 0;

    // =============================================================================
    // Lifecycle
    // =============================================================================
    static init() {
        this.locomotiveScroll = new LocomotiveScroll({
            scrollCallback({ scroll, limit, velocity, direction, progress }) {
                $scroll.set({
                    scroll,
                    limit,
                    velocity,
                    direction,
                    progress
                });

                if (scroll > 20) {
                    $html.classList.add('has-scrolled');
                } else {
                    $html.classList.remove('has-scrolled');
                }

                if (progress > this.lastProgress && this.scrollOrientation != 1) {
                    this.scrollOrientation = 1;
                    document.documentElement.classList.add('scrolling-down');
                } else if (progress < this.lastProgress && this.scrollOrientation != -1) {
                    this.scrollOrientation = -1;
                    document.documentElement.classList.remove('scrolling-down');
                }

                this.lastProgress = progress;
            }
        });
    }

    static destroy() {
        this.locomotiveScroll?.destroy();
    }

    // =============================================================================
    // Methods
    // =============================================================================
    static start() {
        this.locomotiveScroll?.start();
    }

    static stop() {
        this.locomotiveScroll?.stop();
    }

    static addScrollElements(container) {
        this.locomotiveScroll?.addScrollElements(container);
    }

    static removeScrollElements(container) {
        this.locomotiveScroll?.removeScrollElements(container);
    }

    static scrollTo(target, options) {
        this.locomotiveScroll?.scrollTo(target, options);
    }
}
